module.exports = __webpack_public_path__ + "static/media/flowers_yorkshire_getty_tablet.5180da5d.jpg";